import React, { FC } from 'react';
import MuiStep, { StepProps as MuiStepProps } from '@mui/material/Step';
import { BpDesignSystem } from '../../types';

export type StepProps = BpDesignSystem.PropsWithChildren<MuiStepProps>;

export const Step: FC<StepProps> = ({ dataTest, ...rest }) => (
  <MuiStep color="primary" data-test={dataTest} {...rest} />
);
